import { AssignmentRelationType } from "@kolibrisoftware/customerportal-api";
import { useTranslation } from "@kolibrisoftware/hooks-util";
import { useCallback } from "react";

const useAssignmentRelationTypeTranslation = () => {
  const t = useTranslation();

  return useCallback(
    (
      type: AssignmentRelationType = AssignmentRelationType.Vendor,
      forRent: boolean | null = false
    ) => t(`assignmentRelationType.${forRent ? "rent" : "sale"}.${type}`),
    [t]
  );
};

export default useAssignmentRelationTypeTranslation;
